import { cn } from '@/lib/utils';

// Shared input/textarea styling for the resource forms. Extracted so the
// Create and Modify pages render identical-looking controls without
// duplicating the class string.
export function inputClass(invalid: boolean): string {
  return cn(
    'w-full px-3 py-2 rounded-md border bg-background text-sm transition-colors',
    'focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary/50',
    'disabled:opacity-50 disabled:cursor-not-allowed',
    invalid && 'border-destructive focus:ring-destructive/30 focus:border-destructive',
  );
}

export function textareaClass(invalid: boolean): string {
  return cn(inputClass(invalid), 'resize-y');
}

// Native <select> shares the same border/focus/disabled treatment as
// <input>. We let the browser draw its own dropdown indicator — keeps
// this layer dependency-free and consistent with system widgets.
export function selectClass(invalid: boolean): string {
  return cn(inputClass(invalid), 'pr-8');
}
